import Barcode from "react-barcode";

export const SpacingDiv = () => <div style={{ width: '2in', height: '1in' }} />;
// export const BarCodeDiv = ({ value, shortCode }) => (
//   <div
//     style={{
//       width: '2in',
//       height: '1in',
//       position: 'relative',
//       fontFamily: 'Arial, sans-serif',
//       boxSizing: 'border-box',
//       padding: '0.05in',
//     }}
//   >
//     <div
//       style={{
//         width: '100%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'center',
//       }}
//     >
//       <Barcode value={shortCode} format='CODE128' width={1.9} height={40} margin={4} fontSize={10} displayValue={false} />
//       <p style={{ fontSize: '6pt', margin: '3px 0 4px', lineHeight: '1.2' }}>{value}</p>
//       <div
//         style={{
//           width: '100%',
//           paddingLeft: '0.2in', // consistent gap from left
//           fontSize: '5pt',
//           fontWeight: 700,
//           color: 'black',
//           lineHeight: '1.2',
//         }}
//       >
//         {['Full Name:', 'Col. Date:', 'DOB:'].map((label, i) => (
//           <div
//             key={i}
//             style={{
//               display: 'flex',
//               justifyContent: 'flex-start',
//               alignItems: 'baseline',
//               whiteSpace: 'nowrap',
//               marginBottom: '1px',
//               gap: '4px',
//             }}
//           >
//             <span style={{ minWidth: '0.6in', display: 'inline-block' }}>{label}</span>
//             {/* <span style={{ flexGrow: 1, borderBottom: '0.3pt solid black', height: '6pt' }} /> */}
//             <span
//               style={{
//                 width: '1in', // reduced line length
//                 borderBottom: '0.3pt solid black',
//                 height: '6pt',
//                 display: 'inline-block',
//                 // marginLeft:'3px'
//               }}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );
export const BarCodeDiv = ({ value, shortCode }) => (
  <div
    style={{
      width: '2in',
      height: '1in',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box',
      padding: '0.05in',
      marginRight: '0.4in', // <-- adds horizontal space between barcodes
      display: 'inline-block', // <-- ensures divs align side-by-side
    }}
  >
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <Barcode value={shortCode} format='CODE128' width={1.9} height={40} margin={4} fontSize={10} displayValue={false} />
      <p style={{ fontSize: '6pt', margin: '3px 0 4px', lineHeight: '1.2' }}>{value}</p>
      <div
        style={{
          width: '100%',
          paddingLeft: '0.2in',
          fontSize: '5pt',
          fontWeight: 700,
          color: 'black',
          lineHeight: '1.2',
        }}
      >
        {['Full Name:', 'Col. Date:', 'DOB:'].map((label, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'baseline',
              whiteSpace: 'nowrap',
              marginBottom: '1px',
              gap: '4px',
            }}
          >
            <span style={{ minWidth: '0.6in', display: 'inline-block' }}>{label}</span>
            <span
              style={{
                width: '1in',
                borderBottom: '0.3pt solid black',
                height: '6pt',
                display: 'inline-block',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);
